<template>
  <div class="app-single-top-up-btn-wrapper">
    <slot name="txtBefore"></slot>
    <SingleTopUpAmountBtnSelector
      v-if="isPaymentData === true"
      :amounts="singleTopUpStatus_.amounts.amount"
      :default-amount="singleTopUpStatus_.amounts.default"
      :payment="singleTopUpStatus_.payment"
      @showmodal="showModal"
    >
      <template v-for="slot in possibleChildSlotsFor('Amount')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </SingleTopUpAmountBtnSelector>
    <NoPaymentDataView
      v-if="isPaymentData === false"
      :url="url"
    >
      <template v-for="slot in possibleChildSlotsFor('NoPayment')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </NoPaymentDataView>
    <slot name="txtAfter"></slot>
    <ProcessConfirmModal
      :show.sync="modalShow"
      @next="recharge()"
      @back="cancel()"
      :slotData = "slotData"
      :loading="loading"
      :disabled-next="loading"
    >
      <template v-for="slot in possibleChildSlotsFor(slotName)" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ProcessConfirmModal>
  </div>
</template>
<script>

import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import SingleTopUpAmountBtnSelector, { stepName } from './AmountBtnSelector.vue'
import NoPaymentDataView from '../NoPaymentDataView.vue'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'
import ProcessConfirmModal from '@/components/generic/ProcessConfirmModal.vue'
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'SingleTopUpBtnWrapper',
  components: { NoPaymentDataView, SingleTopUpAmountBtnSelector, ProcessConfirmModal },
  props: {
    url: {
      type: String,
      default: '/'
    }
  },
  data () {
    return {
      modalShow: false,
      loading: false,
      selectedAmount: {},
      singleTopUpStatus: {
        amounts: {
          amount: [],
          default: null
        },
        directPossible: false,
        payment: {}
      }
    }
  },
  methods: {
    ...mapMutations('topUp/single', [
      'changeAmount'
    ]),
    ...mapActions('topUp/single', [
      'performSingleTopUp'
    ]),
    async recharge () {
      this.loading = true
      this.changeAmount({ amount: this.selectedAmount.value })
      try {
        await this.performSingleTopUp({ step: stepName })
      } finally {
        this.loading = false
      }
      this.modalShow = false
    },
    cancel () {
      this.modalShow = false
    },
    showModal: function (selected) {
      this.selectedAmount = selected
      this.modalShow = true
    }
  },
  computed: {
    slotData () {
      return {
        selectedAmount: this.selectedAmount,
        payment: this.singleTopUpStatus_.payment
      }
    },
    slotName () {
      if (this.singleTopUpStatus_.payment === null) {
        return 'ConfirmNone'
      }
      return this.singleTopUpStatus_.payment.type === 'creditCard' ? 'ConfirmCredit' : 'ConfirmIban'
    },
    isPaymentData: function () {
      return this.singleTopUpStatus_.directPossible
    },
    singleTopUpStatus_: function () {
      return this.singleTopUpStatus
    }
  },
  mixins: [
    transaction('singleTopUp'),
    slotProxy()
  ],
  apollo: {
    singleTopUpStatus: function () {
      return wrapQuery(
        gql`query singleTopUp {
          singleTopUpStatus {
            directPossible
            amounts {
              amount
              default
            }
            payment {
              ...on BankAccount {
                type
                iban
                owner
              }
              ...on CreditCard {
                type
                holder
                company
                expiryMonth
                expiryYear
                lastDigits
              }
            }
          }
        }`, this, 'singleTopUpStatus', {}, null,
        {
          fetchPolicy: 'cache-first'
        }
      )
    }
  }
}
</script>
